// Job domain *************************************************************************************
// pathname: /v1/domain/detect
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
interface UseSwrJobGenerateQuestionsProps {
  locale: Locale,
  payload: {
    title: string;
    description?: string;
  };
  shouldFetch?: boolean,
  successCallback?: () => void,
}

interface JobGeneratedQuestionsResponse {
  questions: string[];
}

/**
 * @description SWR: fetch job domain.
 * - `locale` - the current locale
 * - `payload` - the payload
 * - `shouldFetch` - condition for fetching the data. Default true.
 * - `successCallback` - success callback; works only on successful fetch
 * - `errorCallBack` - error callback; works only on error fetch
 * - `onDataChanged` - data changed callback; works on every data change (from cache or fetch)
 */
export const useSwrJobGenerateQuestions = (props: UseSwrJobGenerateQuestionsProps) => {
  const {
    locale,
    payload,
    shouldFetch = true,
    successCallback,
  } = props;

  return useSwrApi<JobGeneratedQuestionsResponse>({
    url: '/v1/interview-questions/generate',
    locale,
    shouldFetch,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      payload,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      revalidateOnFocus: false,
      revalidateOnMount: false,
      keepPreviousData: true,
      dedupingInterval: 1000 * 60, // 1 minute
      onSuccess: () => {
        if (successCallback) successCallback();
      },
    },
  });
};
